export default __webpack_public_path__ + "static/media/jpg.9e69b8d0.svg";